export const TEN_OFF_PROMO = '10OffEmail';

export const AUTO_APPLY_PROMO_COOKIE_NAME = 'aap';

export const OLD_10OFF_PARAMETER_VALUE = '10$off';